import { useEffect, useRef, useState } from 'react';
import { useListPresentationContextData } from '../../context/ListPresentationContext';

export function useLastElementObservable() {
  const [showAllItemsRendered, setShowAllItemsRendered] = useState(false);
  const lastItemRef = useRef(null);
  const data = useListPresentationContextData();

  const { itemCountTotal, iterableList } = data.state;
  const { getConfigsAndUtils } = data.utilities;
  const { numItemsToShow, viewAllItemsConfig, containerTracks } =
    getConfigsAndUtils().generalValues;

  // This is total number of items to show finally
  const realCountToShow = viewAllItemsConfig?.areAllItemsVisible
    ? itemCountTotal
    : numItemsToShow;
  // This is initial number of items to show, when user hasn't reached the end of the list
  const virtualizedCount = (containerTracks.numColumns || 0) + 2;
  const totalItemCountToRender = showAllItemsRendered
    ? realCountToShow
    : virtualizedCount;

  const listToRender = iterableList?.slice(0, totalItemCountToRender);

  useEffect(() => {
    if (lastItemRef.current) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setShowAllItemsRendered(true);
          if (lastItemRef.current) observer.unobserve(lastItemRef.current);
        }
      });

      observer.observe(lastItemRef.current);

      return () => {
        if (lastItemRef.current) observer.unobserve(lastItemRef.current);
      };
    }
  }, [listToRender?.length]);

  return [lastItemRef, showAllItemsRendered, listToRender, realCountToShow] as any;
}
